import { Alert } from 'components';
import { RoleGuard } from 'components/RoleGuard';
import { useTranslation } from 'react-i18next';

export const EmptyCard = () => {
	const { t } = useTranslation(['labels']);

	return (
		<Alert variant='warning' className='mt-4'>
			<RoleGuard role='ROLE_ADMIN'>{t('labels:empty_admin')}</RoleGuard>

			<RoleGuard role='ROLE_USER'>{t('labels:empty')}</RoleGuard>
		</Alert>
	);
};
